import React, { useState, useEffect } from "react";
import DefaultBanner from "../../../../../../assets/images/Auditions/default.jpg";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { Markup } from "interweave";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";

const PendingAuditionSlider = (props) => {
  const [pendingAuditions, setPendingAudition] = useState([]);
  const { imageCdnUrl } = useContext(serverInfo);

  useEffect(() => {
    axios.get(`/api/admin/audition/pendings`).then((res) => {
      if (res.status === 200) {
        setPendingAudition(res.data.pending_auditions);
      }
    });
  }, []);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="card card-bg ">
        <div className="py-3">
          <div className="slick-parent d-flex justify-content-center">
            <Slider className="slider-width" {...settings}>
              {pendingAuditions.map((pending, index) => (
                <div key={index} className="p-3" style={{ cursor: "pointer" }}>
                  <div className="completedMeetupBlack">
                    <img
                      src={
                        pending.banner == null
                          ? DefaultBanner
                          : imageCdnUrl+pending.banner
                      }
                      className="img-fluid w-100"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />

                    <div className="p-3">
                      <div className="under-line-warning my-2"></div>
                      <div className="d-flex justify-content-between">
                        <Link
                          to={`/superstar-admin/audition/details/${pending.id}`}
                          className="Link"
                        >
                          <h6 className="text-white text-ellipsis">
                            {pending.title}
                          </h6>
                        </Link>
                      </div>
                      <p className="text-secondary">
                        <Markup content={pending.description}></Markup>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingAuditionSlider;
